import memoizeOne, { type MemoizedFn } from 'memoize-one';
import getMeta from '@atlassian/jira-get-meta';
import type { RouteName } from '@atlassian/jira-route-name-types/src/RouteName.tsx';
import { fg } from '@atlassian/jira-feature-gating';

const FIRST_RELEASE_ROUTES_WITHOUT_LIST: RouteName[] = [
	'issue',
	'issue-embed',
	'rapidboard-backlog',
	'rapidboard-board',
	'rapidboard-report',
	'your-work',
	'projects-directory',
	'boards-directory',
	'filters-directory',
	'dashboards-directory',
	'dashboards-directory-secure',
	'project-components',
	'project-pages',
	'project-versions',
	'software-deployments',
	'software-deployments-classic',
	'software-boards',
	'software-backlog',
	'software-periscope',
	'software-periscope-classic',
	'software-timeline',
	'software-roadmap',
	'software-roadmap-classic',
	'software-timeline-classic',
	'software-code',
	'software-code-classic',
	'software-reports',
	'software-reports-burnup',
	'software-reports-burndown',
	'software-reports-cumulative',
	'software-reports-velocity',
	'software-security',
	'software-security-classic',
	'issue-navigator',
	'global-issue-navigator',
	'issue-navigator-classic',
	'issue-navigator-core',
	'software-issue-navigator',
	'system-dashboard-edit',
];

const FIRST_RELEASE_ROUTES = [
	...FIRST_RELEASE_ROUTES_WITHOUT_LIST,
	'software-list-classic',
	'software-list',
	'classic-business-list',
];

export const LOADER_STYLES_CSS_SELECTOR = 'body::before';
export const LOADER_STYLESHEET_ID = 'loaderStylesheet';
export const DEFAULT_LOADING_BAR_COLOR = 'rgb(76, 154, 255)';

export const getAllowedRoutes: MemoizedFn<() => string[]> = memoizeOne((): string[] => {
	const ALLOWED_ROUTES: string[] = fg('jira_list_nin_merge')
		? FIRST_RELEASE_ROUTES
		: FIRST_RELEASE_ROUTES_WITHOUT_LIST;
	return ALLOWED_ROUTES;
});

export const getLoadingBarColor: MemoizedFn<() => string> = memoizeOne(
	(): string => getMeta('ajs-lf-navigation-highlightcolour') || DEFAULT_LOADING_BAR_COLOR,
);
